var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolitikatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21.813,
    viewBox: "0 0 18 21.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4766",
    "data-name": "Group 4766",
    transform: "translate(-3 -1.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7620",
    "data-name": "Path 7620",
    d: "M21,6.3a2.008,2.008,0,0,0-1.19-1.83l-7-3.11a1.988,1.988,0,0,0-1.62,0l-7,3.11A2.008,2.008,0,0,0,3,6.3V11c0,5.55,3.84,10.74,9,12a11.329,11.329,0,0,0,5.88-3.71l-3.12-3.12a5,5,0,1,1,1.42-1.42l2.9,2.9A12.725,12.725,0,0,0,21,11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9 9)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolitikatIcon);
export default __webpack_public_path__ + "static/media/politikat_icon.b8462b02acc389ba2c90b8cfb2bb1da1.svg";
export { ForwardRef as ReactComponent };